import React, { Component } from "react";
import { Panel } from "react-bootstrap";
import Field from '../Shared/Field';
import SeminarFields from '../Shared/SeminarFields';
import Flags from './Flags';

class SeminarRegistrationPanel extends Component {
  render() {
    const { deal } = this.props

    return (
      <Panel  bsStyle="success" className='compact-panel'>
        <Panel.Heading>
          <Panel.Title componentClass="h3">
          Seminar Registration
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
        {deal.registration_seminar_id ?
            <React.Fragment>
              <Flags deal={deal} />

              <Field label='Registration Number' value={deal.registration_number} />
              {deal.webinar_join_url && <Field label='Webinar Join URL' value={deal.webinar_join_url} />}
              {deal.registration_seminar && <>
                <SeminarFields seminar={deal.registration_seminar} />
                <Field label='Region' value={deal.registration_seminar.region} />
              </>}

            </React.Fragment>
            :
            <div>Not booked yet</div>
          }
        </Panel.Body>
      </Panel>
    )
  }
}

export default SeminarRegistrationPanel